import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetUserChatsDataTypes } from "../../../Schema/getUserChats.types";
import { useAppDispatch, useAppSelector } from "../../../Hooks/useStore";
import { useCallback } from "react";

export type ChatTypes = {
  subServiceId: number;
  messages: GetUserChatsDataTypes[];
  share_token: string;
  images_base_path: string;
};

export type SubServiceChatsInitialStateTypes = {
  chats: ChatTypes[];
  shouldScrollToEnd?: boolean;
  share_token?: boolean;
};

const initialState = {
  chats: [],
  shouldScrollToEnd: false,
} as SubServiceChatsInitialStateTypes;

export const subServiceChatSlice = createSlice({
  name: "subServiceChatSlice",
  initialState,
  reducers: {
    setChats: (
      state,
      action: PayloadAction<{
        messages: GetUserChatsDataTypes[];
        share_token?: string;
        subServiceId: number;
        images_base_path?: string;
      }>,
    ) => {
      const { share_token, ...rest } = action.payload;
      state.chats.push({
        ...rest,
        share_token: share_token ?? "",
      } as ChatTypes);
    },
    setChatMessages: (
      state,
      action: PayloadAction<{
        messages: GetUserChatsDataTypes;
        subServiceId: number;
        share_token?: string;
        images_base_path?: string;
      }>,
    ) => {
      const foundSubService = state.chats.find(
        (chat) => chat.subServiceId === action.payload.subServiceId,
      );

      if (foundSubService) {
        foundSubService.messages.push(action.payload.messages);
      }
    },
    setShouldScrollToEnd: (state, action: PayloadAction<boolean>) => {
      state.shouldScrollToEnd = action.payload;
    },
    setShare_token: (state, action: PayloadAction<boolean>) => {
      state.share_token = action.payload;
    },
    resetFetchedChats: (state) => {
      state.chats = [];
    },
    setSpecificChatMessage: (state, action: any) => {
      let foundSubService = state.chats.find(
        (chat) => chat.subServiceId === action.payload.subServiceId,
      );
    },
  },
});

export const {
  setChats,
  setChatMessages,
  setShouldScrollToEnd,
  resetFetchedChats,
  setSpecificChatMessage,
} = subServiceChatSlice.actions;
export default subServiceChatSlice.reducer;

export const useSubServiceChats = () => {
  const dispatch = useAppDispatch();
  const { chats, shouldScrollToEnd } = useAppSelector((state) => state.subServiceChats);

  const { activeSubService } = useAppSelector((state) => state.activeSubService);
  const currentSubServiceChats = chats
    .filter((item) => !!item.messages)
    .find((chat) => activeSubService?.id === chat.subServiceId);

  const dispatchSetShouldScrollToEnd = useCallback(
    (data: boolean) => {
      dispatch(setShouldScrollToEnd(data));
    },
    [dispatch],
  );

  const dispatchResetFetchedChats = useCallback(() => {
    dispatch(resetFetchedChats());
  }, [dispatch]);

  return {
    chats,
    currentChat: currentSubServiceChats,
    shouldScrollToEnd,
    dispatchSetShouldScrollToEnd,
    dispatchResetFetchedChats,
  };
};
